import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { apply_emergency_pto } from "../../../api/EmergencyPTO/applyepto";
import { getReportsToEmail } from "../../../api/EmergencyPTO/get_reports_to_email";
import { getOrgUserDetails } from "../../../api/users/getOrgUserDetails";
import { useAuthContext } from "../../../hooks";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "react-toastify";

function Index({
  ReportsTo,
  buttonDisabled,
  refershEPto,
  orgUserPtoRef,
  isAvailable,
}: any) {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const [ePto, setEPto] = useState(false);
  const handleShow2 = () => setEPto(true);
  const handleClose2 = () => setEPto(false);
  const [user, setUser] = useState<any>([]);
  const auth = useAuthContext();
  const fetchOrgUser = async () => {
    setUser(
      await getOrgUserDetails(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      )
    );
    console.log("works");
  };
  const [repEmail, setRepEmail] = useState<any>([]);
  const getReportsToEmailFun = async () => {
    setRepEmail(
      await getReportsToEmail(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString()
      )
    );
    console.log("leave history details");
  };
  useEffect(() => {
    fetchOrgUser();

    getReportsToEmailFun();
  }, [repEmail?.[0]?.reports_to_id]);

  const [leaveType, setLeaveTypeId] = useState<any>("");

  const [base64String, setBase64String] = useState("");
  const onImgFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Use optional chaining here

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = String(reader.result).split(",")[1];
        setBase64String(base64String);
      };
    }
  };

  console.log(base64String, "hello see here");
  const handleCreateEmergencyPto = async (e: any) => {
    console.log("function starts creating epto");
    console.debug("data > ", e);
    try {
      const response = await apply_emergency_pto(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        {
          ...e,
          p_first_name:
            auth?.userInfo?.first_name + " " + auth?.userInfo?.last_name,
          p_email: [repEmail?.[0]?.reports_to_email],
          p_leave_type_id: Number(leaveType),
          base_64_string: base64String,
        }
      );
      console.log(response);
      // toast.success("Leave applied successfully");
    } catch (err) {
      console.log("====================================");
      console.log(err);
      console.log("====================================");
      toast.error("error in applying leave");
    }
    console.log(e);
  };

  const onSubmit1 = async (e: any) => {
    // e.preventDefault();
    console.log("I am Here 173");
    await handleCreateEmergencyPto(e);
    console.log("i am here 1731");
    reset();
    await refershEPto();
    await orgUserPtoRef();
    setEPto(false);
  };
  const watchedValue = watch("p_reason");

  return (
    <>
      <Button
        variant="primary"
        onClick={() => handleShow2()}
        className="leave-button"
      >
        Apply Emergency PTO/Comp off
      </Button>

      <Modal size="lg" show={ePto} onHide={handleClose2} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Leave Application</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {user?.map((data: any, idx: any) => {
            return (
              <form onSubmit={handleSubmit(onSubmit1)} key={idx}>
                <div className="form-group">
                  <label>Employee Names:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data?.first_name + " " + data?.last_name}
                    disabled
                  />
                </div>
                <div className="form-group">
                  <label>
                    This Emergency PTO request will be sent to your reporting
                    manager {ReportsTo?.[0]?.reports_to_name}.
                  </label>
                </div>
                <div className="form-group">
                  <label>Leave Type:</label>
                  <select
                    className="form-control"
                    onChange={(e) => setLeaveTypeId(e.target.value)}
                  >
                    <option>Select leave type</option>
                    {isAvailable?.emergencyCount >= 2 ? (
                      <option disabled>You taken your emergency pto</option>
                    ) : (
                      <option value="2">Emergency PTO</option>
                    )}
                    {isAvailable?.compOff >= 4 ? (
                      <option disabled>You have taken all you comp off</option>
                    ) : (
                      <option value="5">Comp Off</option>
                    )}
                  </select>
                </div>
                <div className="form-group">
                  <label className="date">From:</label>
                  <input
                    type="date"
                    className="form-control date1"
                    aria-label="from-date"
                    {...register("p_start_date", {
                      required: "This is required",
                    })}
                  />
                  {/* {errors.p_start_date && (
              <p className="error-message">{errors.p_start_date.message}</p>
            )} */}
                </div>
                <div className="form-group">
                  <label className="date">To:</label>
                  <input
                    type="date"
                    aria-label="from-date"
                    className="form-control date1"
                    {...register("p_end_date", {
                      required: "This is required",
                    })}
                  />
                  {/* {errors.p_end_date && (
              <p className="error-message">{errors.p_end_date.message}</p>
            )} */}
                </div>
                <div className="form-group">
                  <label>Duration:</label>
                  <select
                    className="form-control"
                    aria-label="Default select example"
                    {...register("p_duration", {
                      required: "This is required",
                    })}
                  >
                    <option value="0.125">1 Hour</option>
                    <option value="0.25">2 Hours</option>
                    <option value="0.375">3 Hours</option>
                    <option value="0.5">4 Hours</option>
                    <option value="0.625">5 Hours</option>
                    <option value="0.75">6 Hours</option>
                    <option value="0.875">7 Hours</option>
                    <option value="1">8 Hours</option>
                  </select>
                  {/* {errors.p_duration && (
              <p className="error-message">{errors.p_duration.message}</p>
            )} */}
                </div>
                <div className="form-group">
                  <label>Reason:</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    placeholder="Please give a valid reason for emergency PTO/Comp Off"
                    {...register("p_reason", {
                      required: "This is required",
                    })}
                  />
                  {/* {errors.p_reason && (
              <p className="error-message">{errors.p_reason.message}</p>
            )} */}
                </div>
                <div>
                  {leaveType === 5 || leaveType === "5" ? (
                    <div>
                      <input onChange={onImgFileChange} type="file" />
                    </div>
                  ) : null}
                </div>
                <div className="form-group">
                  {watchedValue?.length > 50 ? (
                    <button className="btn btn-primary" type="submit">
                      Apply Leave
                    </button>
                  ) : (
                    <button className="btn btn-primary" disabled>
                      Apply Leave
                    </button>
                  )}
                </div>
              </form>
            );
          })}
        </Modal.Body>
      </Modal>
    </>
  );
}
export default Index;
